export const VIDEO_SEARCH_API_LIMIT = 12;
export const SEARCH_BOX = 
    {
        VIDEO_SEARCH : 
            {
                COACH_PERSPECTIVE :
                {
                    PACEHOLDER_TEXT : "Search with tag name or user name ..."
                },
                PLAYER_PERSPECTIVE :
                {
                    PACEHOLDER_TEXT : "Search with tag name ..."
                }
            }
    };
export const VIDEO_SEARCH_PAGINATION_MAX_PAGES_DISPLAY = 7;
export const COACH_NOT_ASSIGNED =  {firstName  : "Coach Not Assigned"} ;
export const NEW_FEEDBACKS_NOTIFICATION =  "New AI Feedbacks have been generated, do you want to see them ?" ;